import { Container } from "meta/ui2/layout";
import TopLeftMenu from "../TopMenu/components/TopLeftMenu";
import TopMenu from "../TopMenu";
import AddNewTabButton from "./AddNewTabButton";
import { useRootSelector } from "screens/Root/hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { setActiveTab, setDockedTabActive } from "../slices/rootSlice";
import { getDockedTabIdentification, getTabIdentification, } from "./tabsIdentification";
import DraggableTabs from "./DraggableTabs";
import BottomLine from "../common/BottomLine";
import { useHeadlessMode } from "screens/Root/hooks/useHeadlessModeEnabled";
import { useGlobalShortcutsRoot } from "screens/Root/utils/globalShortcuts";
import { useDeveloperMode } from "../../hooks/useDeveloperMode";
import { useAutoreloadNotifications } from "../NotificationIcons/useAutoreloadNotifications";
import SystemMessages from "./SystemMessages";
const tabsSideMargin = 10;
const AppHeader = () => {
    useDeveloperMode();
    useGlobalShortcutsRoot();
    const dispatch = useDispatch();
    const { appSettings, isLogged, tabs, dockedTabKeys, activeTabKey, activeDockedTabKey, serverInfo, } = useRootSelector();
    const { enabled } = useHeadlessMode();
    if (enabled) {
        useAutoreloadNotifications(60 * 1000);
    }
    const createClickHandler = (key) => () => dispatch(setActiveTab(key));
    const createDockedClickHandler = (key) => () => dispatch(setDockedTabActive(key));
    return enabled ? null : (<Container column flex="1 0 auto">
      <Container id="top-container" flex="1 0 auto">
        <TopLeftMenu appName={{ __html: appSettings.AppNameLongHtml }} serverName={{ __html: serverInfo.name }} showEmergency={isLogged && appSettings.User.IsEmergency}/>
        <TopMenu />
      </Container>
      {isLogged && (<Container style={{ display: "block" }}>
          <SystemMessages />
        </Container>)}
      {isLogged && (<Container data-identification="navigation-tabs" style={{ marginTop: 2 }}>
          <Container flex="1 0 auto">
            <BottomLine style={{ width: tabsSideMargin }}/>
            <DraggableTabs tabs={Object.entries(tabs)
                .filter(([key]) => !dockedTabKeys.includes(key))
                .sort((a, b) => (a[1].order > b[1].order ? 1 : -1))} createClickHandler={createClickHandler} createIdentification={getTabIdentification} active={activeTabKey}/>
            <AddNewTabButton />
            <BottomLine style={{ flexGrow: 1 }}/>
          </Container>
          <Container flex="0 0 auto">
            <DraggableTabs active={activeDockedTabKey || ""} createClickHandler={createDockedClickHandler} createIdentification={getDockedTabIdentification} tabs={Object.entries(tabs)
                .filter(([key]) => dockedTabKeys.includes(key))
                .sort((a, b) => (a[1].order > b[1].order ? 1 : -1))}/>
          </Container>
          <BottomLine style={{ width: tabsSideMargin }}/>
        </Container>)}
    </Container>);
};
export default AppHeader;
